export const TEXTS = {
    COPYRIGHT: "&copy; 2019 Nykaa Fashion Pvt. Ltd. All Rights Reserved",
    DOWNLOAD_APP: "Download our App",
    SUBSCRIBE_NEWSLETTER: "Subscribe to Newsletter",
    ENTER_EMAIL: "enter your email",
    SUBMIT: "Submit",
    FOR_QUERIES: "For Queries",
    CONTACT: "1800 1233 69522",
    EMAIL: "support@nykaafashion.com",
    AVAILABILITY: "(Monday to Saturday, 10AM - 7PM)",
    WHO_WE_ARE: "Who are we",
    HELP: "Help",
    HELP_CENTER: "Help Center",
    QUICKLINKS: "Quicklinks",
    FOLLOW_US: "Follow Us",
    ABOUT_US: "About Us",
    CAREERS: "Careers",
    PRESS: "Press",
    CONTACT_US: "Contact Us",
    TERMS: "Terms & Conditions",
    SHIPPING: "Shipping & Return Policy",
    EU_POLICY: "Privacy Policy for EU Residents",
    RESPONSIBLE_DISCLOSURE: "Responsible Disclosure",
    OFFERS: "Offers",
    SITEMAP: "Sitemap",
    EMAIL_REQUIRED: "Please Enter email id",
    EMAIL_INVALID: "Please Enter valid email id",
    OOPS: "Something went wrong!!!",
    GOOGLE_LINK_NAME: "Google Play Store",
    APPLE_LINK_NAME: "Apple App Store",
};

export const GOOGLE_PLAYSTORE_LINK = "https://play.google.com/store/apps/details?id=com.fsn.nds";
export const GOOGLE_PLAYSTORE_IMG =
    "https://www.nykaafashion.com/pub/media/wysiwyg/homepagemiddle/googlePlay.png";

export const APL_APPSTORE_LINK =
    "https://itunes.apple.com/in/app/nykaa-design-studio/id1439872423?mt=8";
export const APL_APPSTORE_IMG =
    "https://www.nykaafashion.com/pub/media/wysiwyg/homepagemiddle/appleStore.png";

export const INSTA_LINK = "https://www.instagram.com/nykaafashion/";
export const FB_LINK = "https://www.facebook.com/NykaaFashion";

export const FOOTER_LINKS = {
    ABOUT_US: "/about-us.html?root=footer",
    CAREERS: "/careers.html?root=footer",
    PRESS: "https://www.nykaa.com/who_are_we/#press?root=footer",
    CONTACT_US: "/contact_us",
    TERMS: "/terms-and-conditions.html?root=footer",
    SHIPPING: "/shipping-and-return-policy.html?root=footer",
    EU_POLICY: "/privacy-policy.html",
    OFFERS: "/offer.html?root=nav_1&ptype=sale_page",
    SITEMAP: "/sitemap",
    HELP_CENTER: "https://support.nykaafashion.com/hc/en-us",
    RESPONSIBLE_DISCLOSURE: "/responsible-disclosure",
};
